import components__coverages__base from './components__coverages__base.json';
import components__coverages__english from './components__coverages__english.json';

export default {
  ditto_component_library: {
    base: { ...components__coverages__base },
    english: { ...components__coverages__english },
  },
};
